import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgStyle } from '@angular/common';
import { ColorContrastPipe } from '../../../../shared/pipes/color-contrast.pipe';

@Component({
    selector: 'app-select-color',
    templateUrl: './select-color.component.html',
    styleUrls: ['./select-color.component.scss'],
    imports: [
        NgStyle,
        ColorContrastPipe,
    ],
})
export class SelectColorComponent {
    // + přidat boolean pro zapnutí custom colorPicker
    @Input() id: string = 'color';
    @Input() form!: FormGroup;
    @Input() colors = [
        '#F44336',
        '#E91E63',
        '#9C27B0',
        '#673AB7',
        '#3F51B5',
        '#2196F3',
        '#03A9F4',
        '#00BCD4',
        '#009688',
        '#4CAF50',
        '#8BC34A',
        '#CDDC39',
        '#FFEB3B',
        '#FFC107',
        '#FF9800',
        '#FF5722',
        '#795548',
        '#9E9E9E',
        '#607D8B',
    ];

    selectColor(color: string) {
        this.form.patchValue({ [this.id]: color });
    }
}
